<template>
  <BaseButton
    secondary
    :class="$style.btn"
    v-clipboard:copy="value"
    v-clipboard:success="clipboardSuccessHandler"
    v-tooltip="{
        content: `${$t('copiedNotif')}`,
        show: isTooltipOpen,
        trigger: 'manual',
        placement: 'bottom',
      }"
  >
    Copy
    <BaseIcon
      :name="['far', 'clone']"
      :class="$style.icon"
    />
  </BaseButton>
</template>

<script>
export default {
  name: 'copy-block',
  props: {
    value: null
  },
  data () {
    return {
      isTooltipOpen: false
    }
  },
  methods: {
    clipboardSuccessHandler () {
      this.isTooltipOpen = true
      setTimeout(() => {
        this.isTooltipOpen = false
      }, 1600)
    }
  }
}
</script>

<style module lang="scss">
.btn {
  font-weight: 400;
  font-size: 14px;
}
.icon {
  margin-left: 6px;
}
</style>
